import { render, staticRenderFns } from "./GuangzhouUnicom2.vue?vue&type=template&id=e5e8e9d8&scoped=true"
import script from "./GuangzhouUnicom2.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicom2.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicom2.vue?vue&type=style&index=0&id=e5e8e9d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e8e9d8",
  null
  
)

export default component.exports